import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { usePageTitle } from '../hooks/usePageTitle';

export function HomePage() {
  usePageTitle('Home — Hawkes Bridge');
  const { isAuthenticated } = useAuth();

  // FR-018: Redirect authenticated users to Dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="bg-gradient-to-b from-cream to-paper">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        {/* Hero Section */}
        <div className="text-center">
          <h1 className="sr-only">Hawkes Bridge</h1>
          <h2 className="text-4xl sm:text-5xl font-bold text-ink mb-6">
            Study <span className="text-primary-600">Precision Bidding</span> and
            practice bidding in <span className="text-primary-600">Competitive Auctions</span> beginning with an overcall
          </h2>
          <div className="text-xl text-ink-soft w-fit max-w-full mx-auto mb-8 text-left">
            <ol className="list-[lower-alpha] list-inside marker:font-semibold">
              <li>learn the Precision bidding system, and</li>
              <li>practice your responses in competitive auctions beginning with an overcall</li>
            </ol>
            <p className="mt-3">
              through interactive practice problems — train at your own pace and track your
              progress.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/register" className="btn-primary text-lg px-8 py-3">
              Get Started Free
            </Link>
            <Link to="/login" className="btn-secondary text-lg px-8 py-3">
              Login
            </Link>
          </div>
        </div>

        {/* Features Section */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-card rounded-xl shadow-sm p-6 text-center">
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-ink mb-2">Practice Problems</h3>
            <p className="text-ink-soft">
              Work through carefully crafted bidding scenarios to sharpen your skills.
            </p>
          </div>

          <div className="bg-card rounded-xl shadow-sm p-6 text-center">
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-ink mb-2">Multiple Difficulty Levels</h3>
            <p className="text-ink-soft">
              Start with basics and progress to advanced bidding situations.
            </p>
          </div>

          <div className="bg-card rounded-xl shadow-sm p-6 text-center">
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-ink mb-2">Learn as You Go</h3>
            <p className="text-ink-soft">
              Understand the reasoning behind each bidding decision.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
